<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <!--资源迁移-->
          <div class="common-new-title mode2">
            <span>资源迁移</span>
          </div>
          <el-form ref="form" :inline="true" label-width="100px" :model="searchData">
            <el-form-item prop="id" label="客户编码">
              <el-row>
                <el-col :span="17">
                  <el-input clearable placeholder="多个用半角逗号分隔" v-model="searchData.id"></el-input>
                </el-col>
                <el-col :span="6" :offset="1">
                  <el-checkbox
                    v-model="searchData.id_not"
                    :label="'排除'"
                    name="id_not"
                    :value="1"
                  />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="咨询老师">
              <el-select v-model="searchData.crm_sayer" clearable placeholder="请选择" filterable>
                <el-option-group v-for="(group, k) in teachers" :key="k" :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.truename"
                    :value="item.userid"
                  />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="客户分级">
              <jm-dict-select
                clearable
                type="dataset"
                v-model="searchData.customerClassification"
                dict-type="student"
                name="customLvType"
                :filter="(item) => { return $hasPermission([1, 80, 30, 77, 62, 89]) || item.value !== 66; }"
              />
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="searchData.showIgnore">包含放弃资源</el-checkbox>
            </el-form-item>
            <el-form-item label="创建日期">
              <el-date-picker
                clearable
                :editable="false"
                v-model="searchData.creationDate"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"
              />
            </el-form-item>
            <el-form-item label="最后回访时间">
              <el-date-picker
                clearable
                :editable="false"
                v-model="searchData.lastvisittime2"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"
              />
            </el-form-item>
            <el-form-item label="推广人">
              <el-select v-model="searchData.custom_promoter" placeholder="请选择" multiple filterable clearable>
                <el-option-group
                  v-for="(group, k) in ds.create_person"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group.filter(item => item.userid > 0)"
                    :key="item.userid"
                    :label="item.username"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="">
              <el-checkbox
                class="no-content-item"
                v-model="searchData.custom_promoter_ex">排除</el-checkbox>
            </el-form-item> -->
            <el-form-item label="创建人">
              <el-select v-model="searchData.create_person" placeholder="请选择" filterable clearable>
                <el-option-group
                  v-for="(group, k) in ds.create_person"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.username"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <jm-channel v-model="channel" :is-all="true" clearable filterable />
            </el-form-item>
            <el-form-item label="渠道号">
              <el-input v-model="searchData.custom_final_from" clearable placeholder="填写此项将忽略渠道" />
            </el-form-item>
            <el-form-item label>
              <el-button type="primary" @click="handelSearch">筛选</el-button>
              <el-button type="default" @click="handelReset">重置</el-button>
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="100px" style="background-color:#f5f5f5;padding-top:20px;margin-bottom:15px">
            <el-form-item label="迁移类型">
              <el-select v-model="postData.field" ref="field" placeholder="请选择" clearable filterable>
                <el-option key="crm_sayer" label="咨询老师" value="crm_sayer"/>
                <el-option key="custom_promoter" label="推广人" value="custom_promoter"/>
                <el-option key="create_person" label="创建人" value="create_person"/>
              </el-select>
            </el-form-item>
            <el-form-item label="接受者">
              <!--创建人-->
              <el-select :disabled="!postData.field" v-if="postData.field === 'create_person'" v-model="postData.receiver" placeholder="请选择" clearable filterable>
                <el-option-group
                  v-for="(group, k) in ds.create_person"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.username"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
              <!--咨询老师/推广人-->
              <el-select :disabled="!postData.field" v-else v-model="postData.receiver" placeholder="请选择" filterable clearable>
                <el-option-group
                  v-for="(group, k) in ds.create_person"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group.filter(item => item.userid > 0)"
                    :key="item.userid"
                    :label="item.username"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="数量">
              <el-input type="number" v-model="postData.amount" />
            </el-form-item>
            <el-form-item>
              <el-button class="jm-input135" type="danger" @click="handelTransfer">转移</el-button>
            </el-form-item>
          </el-form>

          <jm-table-list
            :refresh.sync="refresh"
            url="/index/student/pagetable"
            :search-data="searchData"
            row-key="id"
          >
          </jm-table-list>
        </div>
      </div>
    </div>
    <el-dialog
      :title="transferTaskCompleted ? '资源迁移完成' : '资源迁移中...'"
      :visible.sync="taskProgressVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
      <el-progress
        ref="taskProgress"
        style="width: 100%;line-height: 40px;"
        :text-inside="true"
        :stroke-width="20"
        :percentage="transferTaskPercent"/>
      <p v-if="transferTaskCompleted" style="font-size:12px; color:#39f">资源迁移已完成！</p>
      <p v-else style="font-size:12px; color:#999">迁移进度未完成，请不要关闭当前页面！</p>
      <div slot="footer">
        <el-button @click="handelFinish" type="primary" size="small" :disabled="!transferTaskCompleted">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';
import studentMixin from '../student/student';
import { jmChannel, jmDictSelect } from '@/components/tool';

const MAX_PAGES = 100; // 最大页数
const PAGE_LIMIT = 100; // 每页数据限制
const transferTask = { // 迁移任务
  total: 0, // 任务总数
  completed: 0, // 完成总数
  init(amount) {
    this.total = amount;
    this.completed = 0;
  },
  addCompleted(finish) {
    this.completed += finish;
  },
  getBalance() {
    return this.total - this.completed;
  },
  getPercent() {
    if (!this.total) { return 0; }
    return Math.ceil((this.completed / this.total) * 100);
  },
};

export default {
  mixins: [studentMixin],
  components: {
    jmTableList,
    jmChannel,
    jmDictSelect
  },
  data() {
    return {
      refresh: false,
      postData: {
        field: '',
        receiver: '',
        amount: 1,
      },
      channel: {},
      channel_id: '',
      searchData: {},
      transferTask,
      taskProgressVisible: false
    };
  },
  computed: {
    transferTaskPercent() {
      return this.transferTask.getPercent();
    },
    transferTaskCompleted() {
      return this.transferTask.total > 0 && this.transferTask.getBalance() === 0;
    },
    teachers() {
      return this.ds.advisory_teacher;
    }
  },
  methods: {
    handelSearch() {
      if (!this.channel_id || this.channel_id === '') {
        this.searchData.channel = this.channel;
        this.refresh = true;
      } else {
        this.$http._post({
          url: '/training/channel/getChannelMap',
          data: {
            channel_id: this.channel_id
          }
        }).then(({ data }) => {
          this.searchData.channel = data.channels;
          this.channel = {};
          this.refresh = true;
        });
      }
    },
    handelReset() {
      this.channel_id = '';
      this.channel = {};
      this.searchData = {
        showIgnore: false
      };
    },
    async handelTransfer() {
      if (!this.postData.field) {
        this.$message.error('迁移类型不能为空');
        return false;
      }
      if (!this.postData.receiver) {
        this.$message.error('接受者不能为空');
        return false;
      }

      const amount = parseInt(this.postData.amount, 10);
      if (!amount) {
        this.$message.error('请输入数量');
        return false;
      }

      const max = MAX_PAGES * PAGE_LIMIT;
      if (amount > max) {
        this.$message.error(`请输入小于${max}的数量`);
        return false;
      }

      // 任务初始化
      this.transferTask.init(amount);
      try {
        await this.$confirm('确定要进行资源迁移', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 开启进度条
        this.taskProgressVisible = true;

        // 执行迁移操作
        await this.doTansferTask(0);
      } catch (e) {
        this.taskProgressVisible = false;
        // this.$message.warning('操作异常，取消资源迁移');
      }
    },
    async doTansferTask(taskId) {
      // 未完成任务量
      let balance = this.transferTask.getBalance();
      if (balance <= 0) {
        return false;
      }
      // 当前任务 ID
      const max = MAX_PAGES * PAGE_LIMIT;
      if (taskId > MAX_PAGES) {
        this.$message.error(`迁移数量不能多于${max}条`);
      }

      // 当前处理量
      let amount = balance < PAGE_LIMIT ? balance : PAGE_LIMIT;
      // 提交数据
      const postData = Object.assign(
        {},
        this.postData,
        { amount: amount, _taskId: taskId }
      );
      await this.$http._post({
        url: '/index/student/doTransfer',
        data: {
          postData: postData,
          searchData: this.searchData,
        }
      });
      this.transferTask.addCompleted(amount);
      taskId++;
      await this.doTansferTask(taskId);
    },
    handelFinish() {
      // 迁移成功
      this.taskProgressVisible = false;
      // 重新刷新
      this.refresh = true;
    },
  },
  mounted() {
    this.getDatasource();
  }
};
</script>
<style scoped>
.basic-title em.normal {
  border-bottom: none;
  color: #ccc;
}
</style>
